// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3ktj6","title":"BackImages_title__2lzf8","images":"BackImages_images__2IOGK"};